import { isAndroid } from '@kibt/krn-utils';
import { isAndroidKDS } from '../device-info';
import { kwaiInvoke } from '@kibt/bridge';
import { getAppProps } from '@/Navigation';

/**
 * 获取容器类型
 */
export async function getCurrentContainerType(): Promise<'halfScreen' | 'fullScreen'> {
    if (isAndroidKDS || isAndroid) {
        try {
            const res: any = await kwaiInvoke('component.getCurrentContainerType', {});
            if (res?.type?.includes('Fragment')) {
                return 'halfScreen';
            }
        } catch (e) {
            console.trace(e);
        }
    } else {
        const { foldRatio } = getAppProps();
        return foldRatio ? 'halfScreen' : 'fullScreen';
    }
    return 'fullScreen';
}
